<template>
  <div id="app">
    <nav class="header_dropzone">
    <div class="overlay" v-show="showLoader">
      <div class="screen">
        <div class="loaderImg"><img class="align_center_screen" src="./assets/loader.gif" alt="logo"></div> 
       <!--- <div class="loading-spinner">
         <span class="dot dotOne"></span>
         <span class="dot dotTwo"></span>
         <span class="dot dotThree"></span>
       </div>-->
      </div>
    </div>
      <div class="container">
        <ul class="nav__left">
          <li>
            <span @click.capture="clicked">
              <router-link to="/admin">
              <span><img src="./assets/pleiades_logo.png" alt="logo"></span>
              </router-link>
            </span>
          </li>
          <li class="align_middle"><span class="separatorBlock"></span></li>
          <li class="align_middle"><span class="drpText">Dropzone</span></li>
        </ul>
        <ul class="nav__right">
          <li class="align_middle">
            <span class="grey_text dis_blk">{{ $t("message.front_page.welcome") }}</span>
            <span class="fntRoboto">{{userId}}<span class="grey_text_author"></span></span>
          </li>
          <li class="align_middle"><span class="separatorBlock sb32"></span></li>
          <li class="align_middle">
            <span class="grey_text dis_blk fntRoboto">{{ $t("message.front_page.select_lang") }}</span>          
            <span class="blue_text fntRoboto" id="langDropdown"><select v-on:change="onDrpChange"><option value="en">English</option><option value="ru">русский</option> </select></span>
          </li>
        </ul>
      </div>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>
import toastr from 'toastr'

import {
  ERROR_MSG,
  FILES_UPLOAD_SUCCESS,
  DOWNLOADING_SUCCESS,
  NOTIFY_SUCCESS
} from './store/mutation-types'
export default {
  name: 'app',
  data () {
    return {
      userId: ''
    }
  },
  created () {
    this.userId = this.$route.query.userid
    this.$store.subscribe(function (mutation) {
      if (mutation.payload) {
        switch (mutation.type) {
          case ERROR_MSG:
            toastr.error(mutation.payload.content, mutation.payload.title)
            break
          case FILES_UPLOAD_SUCCESS:
            toastr.success('Files uploaded.', 'Success')
            break
          case DOWNLOADING_SUCCESS:
            toastr.success('Files downloaded.', 'Success')
            break
          case NOTIFY_SUCCESS:
            toastr.success('Notified.', 'Success')
            break
        }
      }
    })
  },
  computed: {
    showLoader () {
      return this.$store.state.showLoader
    }
  },
  methods: {
    clicked: function (e) {
      e.preventDefault()
    },
    onDrpChange: function (e) {
      this.$i18n.locale = e.target.value
      console.log(e)
    }
  }
}
</script>

<style>
  .drpDownLang{
    border: none;
    background: transparent;
    right: 4px;
    position: relative;
    outline:opx;
  }
  .overlay {
    background: rgba(255, 255, 255, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .loading-spinner {
    z-index: 4;
    position : absolute;
    top      : 50%;
    left     : 50%;
    -webkit-transform : translateX(-50%) translateY(-50%);
    -moz-transform : translateX(-50%) translateY(-50%);
    transform : translateX(-50%) translateY(-50%);
  }

  .dot {
    background    : black;
    border-radius : 1%;
    color         : white;
    height        : 10px;
    line-height   : 8px;
    text-align    : center;
    width         : 10px;
  }

  .dotOne {
    -webkit-animation : dotOneKeyframes 5s ease  infinite;
    background        : #49628A;
    position          : absolute;
    top               : 0;
    left              : 0;
  }

  .dotTwo {
    -webkit-animation : dotTwoKeyframes 5s ease 0.4166666666666s infinite;
    background        : #EFDB06;
    position          : absolute;
    top               : 0;
    left              : 14px;
  }

  .dotThree {
    -webkit-animation : dotThreeKeyframes 5s ease 0.83333333333s infinite;
    background        : #DBC906;
    position          : absolute;
    top               : 14px;
    left              : 14px;
  }

  @-webkit-keyframes dotOneKeyframes {
    0% {
      top  : 0;
      left : 0;
    }
    8.3333333333% {
      top  : 14px;
      left : 0;
    }
    16.6666666666% {

    }
    25% {
      top  : 14px;
      left : 0;
    }
    33.3333333333% {
      top  : 14px;
      left : 14px;
    }
    41.6666666666% {

    }
    50% {
      top  : 14px;
      left : 14px;
    }
    58.3333333333% {
      top  : 0;
      left : 14px;
    }
    66.6666666666% {

    }
    75% {
      top  : 0;
      left : 14px;
    }
    83.3333333333% {
      top  : 0;
      left : 0;
    }
    91.6666666666% {

    }
    100% {

    }
  }


  @-webkit-keyframes dotTwoKeyframes {
    0% {
      top  : 0;
      left : 14px;
    }
    8.3333333333% {
      top  : 0;
      left : 0;
    }
    16.6666666666% {

    }
    25% {
      top  : 0;
      left : 0;
    }
    33.3333333333% {
      top  : 14px;
      left : 0;
    }
    41.6666666666% {

    }
    50% {
      top  : 14px;
      left : 0;
    }
    58.3333333333% {
      top  : 14px;
      left : 14px;
    }
    66.6666666666% {

    }
    75% {
      top  : 14px;
      left : 14px;
    }
    83.3333333333% {
      top  : 0;
      left : 14px;
    }
    91.6666666666% {

    }
    100% {

    }
  }

  @-webkit-keyframes dotThreeKeyframes {
    0% {
      top  : 14px;
      left : 14px;
    }
    8.3333333333% {
      top  : 0;
      left : 14px;
    }
    16.6666666666% {

    }
    25% {
      top  : 0;
      left : 14px;
    }
    33.3333333333% {
      top  : 0;
      left : 0;
    }
    41.6666666666% {

    }
    50% {
      top  : 0;
      left : 0;
    }
    58.3333333333% {
      top  : 14px;
      left : 0;
    }
    66.6666666666% {

    }
    75% {
      top  : 14px;
      left : 0;
    }
    83.3333333333% {
      top  : 14px;
      left : 14px;
    }
    91.6666666666% {

    }
    100% {

    }
  }
.loaderImg{
   display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}  
</style>



// WEBPACK FOOTER //
// App.vue?7ef4d7c2